import type { RecordOfMatchesState } from './betting/betting-entities';

/**
 * Ordered matches by `startDate` field
 */
export function orderByGlobalPriority<T extends Array<number>>(
  matchesById: RecordOfMatchesState['byId'],
  matchIds: T,
): T {
  return [...matchIds].sort((firstId, secondId) => {
    const firstMatch = matchesById.get(firstId);
    const secondMatch = matchesById.get(secondId);

    if (firstMatch && secondMatch) {
      return firstMatch.globalPriority?.localeCompare(secondMatch.globalPriority);
    }

    return 0;
  }) as T;
}
